module.exports = __webpack_public_path__ + "static/media/flag-eo.97466519.webp";